export default __webpack_public_path__ + "static/diceIcon-8f4712266670fd5cd6ad4d28535431e7.svg";